module.exports = __webpack_public_path__ + "img/pic.17934e20.png";